import React, { useState, useEffect } from "react";
import { Form, Input, Button, Row, Col, Card, Table, Tag, notification, Select } from "antd";
import {useLocation} from 'react-router-dom'
import styled from "styled-components";
import axios from 'axios'

const {Option} = Select

const Detail = () => {
    const token = localStorage.getItem("token")
    const loc = useLocation()
    const [name, setname] = useState("")
    const [wa_number, setWaNumber] = useState("")
    const [active, setActive] = useState(true)
    const [oriData, setoridata] = useState({})
    const [loading, setLoading] = useState(false)

    const getData = async (id) => {
        let fetch = await axios.get('https://api.rajarental.co.id/api/v1.0/admin/whatsapp-contact/' + id, {headers: {
          Authorization: token
        }})

        if(fetch) {
            let data = fetch.data.response
          setname(data.name)
          setWaNumber(data.wa_number)
          setActive(data.active ? "Active" : "Inactive")
          setoridata(data)
        }
      }

      useEffect(() => {
        if(loc.search && loc.search !== "") {
            getData(loc.search.split("?")[1].split("=")[1])
        }
      }, [])

      const submitForm = async () => {
          try {
              setLoading(true)
              
              if(loc.search && loc.search !== "") {
                  let id = loc.search.split("?")[1].split("=")[1]
                  let body = {}
                  let state = {
                    name,
                    wa_number,
                    active: active == "Active" ? true : false
                  }
                  for(let key in oriData) {
                      if(oriData[key] != state[key]) {
                          body[key] = state[key]
                      }
                  }
                  if(name !== "" &&
                    wa_number !== ""
                ) {
                      let update = await axios.put('https://api.rajarental.co.id/api/v1.0/admin/whatsapp-contact/' + id, 
                          body,{headers: {
                        Authorization: token
                    }})

                    if(update) {
                        setLoading(false)
                        notification["success"]({
                            message: "Success Edit Whatsapp number",
                        });
                        window.location.href = "/dashboard/whatsapp"
                    }
                  } else {
                    setLoading(false)
                    notification["warning"]({
                        message: "Semua field wajib diisi",
                        description:
                          "Please try again",
                      });
                  }
                  
              } else {
                  if(name !== "" &&
                  wa_number !== "" ) {
                    let create = await axios.post('https://api.rajarental.co.id/api/v1.0/admin/whatsapp-contact/', {
                        name,
                          wa_number,
                          active: active == "Active" ? true : false
                    },{headers: {
                        Authorization: token
                    }})

                    if(create) {
                        setLoading(false)
                        notification["success"]({
                            message: "Success Add Whatsapp number",
                        });
                        window.location.href = "/dashboard/whatsapp"
                    }
                  } else {
                    setLoading(false)
                    notification["warning"]({
                        message: "Semua field wajib diisi",
                        description:
                          "Please try again",
                      });
                  }
                
              }
          } catch (error) {

            console.log(error)
            setLoading(false)
            notification["warning"]({
                message: "Error",
                description:
                  "Please try again",
              });
          }
      }

    

    

    // console.log(username)

    return (
        <React.Fragment>
            <Card size="small" style={{padding: "20px 30px"}}>
                <Row justify="space-between">
                    <Col span={11}>
                        <p style={{marginBottom: 5}}>Name</p>
                        <Input value={name} onChange={(e) => setname(e.target.value)}/>
                    </Col>
                    
                    <Col span={11}>
                        <p style={{marginBottom: 5}}>Whatsapp Number</p>
                        <Input value={wa_number} onChange={(e) => setWaNumber(e.target.value)}/>
                    </Col>
                    
                    <Col span={11} style={{marginTop: 25}}>
                        <p style={{marginBottom: 5}}>Status</p>
                        <Select style={{display: 'block'}} value={active} onChange={(e) => setActive(e)}>
                            <Option value={"Active"} title="Active"/>
                            <Option value={"Inactive"} title="Inactive"/>
                        </Select>
                    </Col>
 
                    <Col span={24}>
                        <Button style={{float: 'right', marginTop: 25}} type="primary" loading={loading} onClick={submitForm}>Submit</Button>
                    </Col>
                    
                </Row>
            </Card>
        </React.Fragment>
    )
}

export default Detail